<if=input.image && input.image.src>
  <img
    class=(input.class || false)
    src=input.image.src
    srcset=(input.image.srcSet || false)
    sizes=(input.sizes || input.image.sizes || false)
    width=input.image.width
    height=(input.height || input.image.height || false)
    alt=(input.alt || "")
    loading=(input.priority === "high" ? "eager" : "lazy")
    fetchpriority=(input.priority === "high" ? "high" : false)
    decoding="async"
    data-ll-hero-art=(input.hero ? "" : false)
  >
</if>
